// Posts index file
// Add your blog posts here with metadata
// Markdown files should be placed in the public/posts directory

export const posts = [
  {
    id: 'wall-of-shame',
    title: 'Wall of Shame',
    date: '2025-12-06',
    slug: 'wall-of-shame',
    filename: 'wall-of-shame.md',
  },
  {
    id: 'wos-hop-protocol',
    title: '😭👉🐇 Hop Protocol',
    date: '2026-01-25',
    slug: 'wos-hop-protocol',
    filename: 'wos-hop-protocol.md',
  },
  // Add more posts here as you create them
  // Example:
  // {
  //   id: 'my-new-post',
  //   title: 'My New Post',
  //   date: '2024-01-15',
  //   slug: 'my-new-post',
  //   filename: 'my-new-post.md',
  // },
];

// Helper function to get post by slug
export function getPostBySlug(slug) {
  return posts.find(post => post.slug === slug);
}

// Helper function to get all posts sorted by date (newest first)
export function getAllPosts() {
  return [...posts].sort((a, b) => new Date(b.date) - new Date(a.date));
}

// Helper function to fetch post content
export async function fetchPostContent(filename) {
  try {
    const response = await fetch(`/posts/${filename}`);
    if (!response.ok) {
      throw new Error(`Failed to fetch post: ${filename}`);
    }
    return await response.text();
  } catch (error) {
    console.error('Error fetching post content:', error);
    return null;
  }
}

